import React from 'react';
import SiteManagerComponent from '../components/SiteManagerComponent';

function Sites() {
    return (
        <div>
            <h1>Sites</h1>
            <SiteManagerComponent />
        </div>
    );
}

export default Sites;
